/* eslint-disable */
<template>
  <span>
    <div
      class="background-wallpaper"
      style="background-image: url(https://wallpapercave.com/wp/wp6896343.jpg)"
    ></div>
    <section style="margin-top: 100px">
      <div class="container content flex">
        <div
          class="column c4 text-center"
          style="margin-top: 50px; margin-right: auto"
        >
          <div
            v-if="album.AlbumArtwork !== null"
            :key="album.slug"
            class="text-left album-art"
          >
            <img
              :src="album.AlbumArtwork.url"
              style="width: 100%; margin: auto"
            />
            <div v-if="album.PlayerID !== null" class="buy-button">
              <i class="fab fa-bandcamp"></i>
              <a
                style="text-decoration: none"
                :href="album.bandcamp"
                target="_blank"
                >BUY NOW FROM BANDCAMP
              </a>
            </div>
          </div>
        </div>
        <div class="column c7 text-left" style="margin-top: 50px">
          <span v-if="album.PlayerID !== null">
            <span v-if="album.album_type.Type !== 'Single'">
              <iframe
                style="border: 0; width: 100%; height: 241px"
                :src="
                  'https://bandcamp.com/EmbeddedPlayer/album=' +
                  album.PlayerID +
                  '/size=large/bgcol=333333/linkcol=9a64ff/artwork=none/transparent=true/'
                "
                seamless
              ></iframe>
            </span>
            <span v-else>
              <iframe
                style="border: 0; width: 100%; height: 241px"
                :src="
                  'https://bandcamp.com/EmbeddedPlayer/track=' +
                  album.PlayerID +
                  '/size=large/bgcol=333333/linkcol=9a64ff/artwork=none/transparent=true/'
                "
                seamless
              ></iframe>
            </span>
          </span>
          <div v-else-if="album.id === 33">
            <h2> Subscribe to download </h2>
            <p>
               To download this Album, you will need to subscribe to our mailing List, an email with the download link will be sent to you.
            </p>
            <a class="subbutton" href="http://eepurl.com/hQ3RUP">SUBSCRIBE</a>
            <br><br>
            <hr>
          </div>
          <span v-else>
            <div
              style="
                width: 95%;
                background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1636802264/7_dark_7f405b1251.png);
              "
            >
              <h1
                style="
                  padding: 120px 20px;
                  margin-top: 0px;
                  opacity: 0.5;
                  text-align: center;
                "
              >
                OUT SOON!
              </h1>
            </div>
          </span>
          <div style="clear: both; height: 25px"></div>

          <h1>{{ album.AlbumTitle }}</h1>
          <h2 style="margin-bottom: 0px; padding-bottom: 0px">
            {{ album.album_type.Type }} by
            <span v-for="artist in album.artists" :key="artist.slug">
              <router-link
                style="text-decoration: underline"
                :to="{ name: 'artist', params: { id: artist.slug } }"
                >{{ artist.name }}</router-link
              >
            </span>
            {{ album.ArtistOverRide }}

            <div
              v-for="artist in album.artists"
              :key="artist.id"
              class="release-profile2"
            >
              <router-link
                style="text-decoration: underline"
                :to="{ name: 'artist', params: { id: artist.slug } }"
              >
                <img :src="artist.profile.url" width="100%" />
              </router-link>
            </div>
          </h2>
          <div style="clear: both; height: 25px"></div>
          <p class="text-left" v-html="album.AlbumText"></p>
        </div>
      </div>
    </section>
  </span>
</template>

<script>
import axios from 'axios'

export default {
  name: 'release',
  data () {
    return {
      album: []
    }
  },
  created () {
    axios
      .get(
        'https://admin.patronusrecords.com/albums/?slug=' +
          this.$route.params.id
      )
      .then((response) => {
        this.album = response.data[0]
        window.document.title = 'Patronus Records - ' + this.album.AlbumTitle
      })
  }
}
</script>
<style scoped>
a.subbutton {
  width:100%;
  display: block;
  text-align: center;
  padding:10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: 800;
  background-color: var(--secondary);
}
</style>
<style>
.buy-button {
  padding: 10px;
  background-color: var(--secondary);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  text-align: center;
}
.release-profile {
  float: left;
  width: 150px;
  margin-right: 32px;
  border-radius: 25px;
}
.release-profile2 {
  float: right;
  width: 82px;
  overflow: hidden;
  margin-right: 32px;
  border-radius: 100px;
  margin-top: -55px;
}
@media only screen and (max-width: 600px) {
  .album-art {
    margin-top: -90px;
  }
  .release-profile2 {
    float: none;
    margin: auto;
    margin-top: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/release.vue